import type { ContainerStatus } from '../types/import-tracking.types';

export const CONTAINER_COLORS = [
  '#3B82F6', // blue
  '#EF4444', // red
  '#10B981', // emerald
  '#F59E0B', // amber
  '#8B5CF6', // violet
  '#EC4899', // pink
  '#06B6D4', // cyan
  '#F97316', // orange
  '#84CC16', // lime
  '#6366F1', // indigo
  '#14B8A6', // teal
  '#A855F7', // purple
];

export function getItemColor(index: number): string {
  return CONTAINER_COLORS[index % CONTAINER_COLORS.length];
}

/** Colores 3D del contenedor según su status */
export const CONTAINER_STATUS_3D_COLORS: Record<ContainerStatus, string> = {
  EMPTY: '#94a3b8', // slate
  LOADING: '#f59e0b', // amber
  SEALED: '#3b82f6', // blue
  IN_TRANSIT: '#6366f1', // indigo
  AT_PORT: '#f97316', // orange
  DELIVERED: '#22c55e', // green
};

/** Colores para franjas y badges en la UI */
export const CONTAINER_STATUS_UI_COLORS: Record<ContainerStatus, string> = {
  EMPTY: 'bg-slate-400',
  LOADING: 'bg-amber-500',
  SEALED: 'bg-blue-500',
  IN_TRANSIT: 'bg-indigo-500',
  AT_PORT: 'bg-orange-500',
  DELIVERED: 'bg-green-500',
};

/** Colores de texto para iconos de status */
export const CONTAINER_STATUS_TEXT_COLORS: Record<ContainerStatus, string> = {
  EMPTY: 'text-slate-500',
  LOADING: 'text-amber-600',
  SEALED: 'text-blue-600',
  IN_TRANSIT: 'text-indigo-600',
  AT_PORT: 'text-orange-600',
  DELIVERED: 'text-green-600',
};
